module.exports = __webpack_public_path__ + "static/media/resultunimarcdos.998505f6.png";